// src/components/Header.jsx
import React from "react";

const Header = ({ currentPage, setCurrentPage }) => {
  const isHomePage = currentPage === "home";

  // 动态文字颜色类
  const textColorClass = isHomePage ? "text-white" : "text-gray-800";
  const subTextColorClass = isHomePage ? "text-blue-200" : "text-blue-600";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        isHomePage
          ? "bg-white/10 backdrop-blur-sm border-b border-white/20"
          : "bg-white/80 backdrop-blur border-b border-gray-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-gradient-to-r from-blue-600 via-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg">
              <span className="text-white font-bold text-2xl">西</span>
            </div>
            <div>
              <h1 className={`text-2xl font-bold ${textColorClass}`}>
                西航投（云南）新能源有限公司
              </h1>
              <p className={`text-sm ${subTextColorClass}`}>
                赋能绿色未来 · 智领能源转型
              </p>
            </div>
          </div>
          <nav className="hidden md:flex space-x-1">
            {[
              { id: "home", label: "首页" },
              { id: "about", label: "关于我们" },
              { id: "business", label: "核心业务" },
              { id: "tenders", label: "招标信息" },
              { id: "suppliers", label: "入围供应商" },
              { id: "contact", label: "联系我们" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 text-sm ${
                  currentPage === item.id
                    ? "bg-gradient-to-r from-blue-600 to-emerald-600 text-white shadow-lg"
                    : isHomePage
                    ? "text-blue-200 hover:bg-white/20 hover:text-white"
                    : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;